import {ACCOUNTED_DETAIL_ADMIN_LIVE_SUCCESS,
    ACCOUNTED_DETAIL_ADMIN_LIVE_ERROR,
    ACCOUNTED_DETAIL_ADMIN_LIVE_START,
    CLEAR_LIVE_TRIP_ACCOUNT_DETAIL
} from '../Constants/TourAccountDetailConstant'
const initialState = {
    loading: false,
    data: [],
};

export default function TourAccountDetailReducer(
    state = { ...initialState },
    action
) {
    switch (action.type) {
        case ACCOUNTED_DETAIL_ADMIN_LIVE_START:
            return {
                ...state,
                loading: true,
            };
        case ACCOUNTED_DETAIL_ADMIN_LIVE_SUCCESS:
            return {
                ...state,
                data: action.payload,
                loading: false,
            };
        case ACCOUNTED_DETAIL_ADMIN_LIVE_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
            case CLEAR_LIVE_TRIP_ACCOUNT_DETAIL:
                return {
                    ...state,
                    data: [],
                    loading: false,
                };
        default:
            return state;
    }
}
